import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-8 bg-transparent relative overflow-hidden" data-id="element-64">
      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-65">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-8 leading-tight" data-id="element-66">
          Si vas a invertir en tu práctica, que sea en una herramienta que
          realmente te ahorre tiempo y{' '}
          <span className="text-gradient" data-id="element-67">eleve tu nivel profesional.</span>
        </h2>

        <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-68">
          MegaPack Fonoaudiología te da recursos, estructura y practicidad para
          trabajar mejor desde hoy.
        </p>

        <p className="text-sm text-orange-200/70 font-medium" data-id="element-69">
          La mayoría elige la opción más completa porque concentra más valor y
          resuelve mejor sus necesidades profesionales.
        </p>
      </div>
    </section>;
}